import { GetServiceByIdSuccessAction, getServiceCategoriesSuccessAction, getServicesSuccessAction } from "./action";
import { GET_SERVICE_BY_ID_API, GET_SERVICE_BY_ID_API_ERROR, GET_SERVICE_BY_ID_API_SUCCESS, GET_SERVICE_CATEGORIES_API, GET_SERVICE_CATEGORIES_API_ERROR, GET_SERVICE_CATEGORIES_API_SUCCESS, GET_SERVICES_API, GET_SERVICES_API_ERROR, GET_SERVICES_API_SUCCESS, UPSERT_SERVICE_API, UPSERT_SERVICE_API_ERROR, UPSERT_SERVICE_API_SUCCESS, UPSERT_SERVICE_CATEGORY_API, UPSERT_SERVICE_CATEGORY_API_ERROR, UPSERT_SERVICE_CATEGORY_API_SUCCESS } from "./actionTypes";
import { ServiceError, ServiceErrorOrigin } from "./types";
import { parseDataKey } from "src/common/util";
import { ErrorAction } from "src/common/apiLoader/state/actions";
import { Service } from "src/common/models/service";
import { ServiceCategory } from "src/common/models/serviceCategory";

export interface ServiceState {
    services: Service[]
    error: ServiceError | undefined
    isUpsertingService: boolean
    upsertServiceSuccess: boolean
    serviceCategories?: ServiceCategory[]
    isUpsertingServiceCategory: boolean
    upsertServiceCategorySuccess: boolean
    currentService?: Service
}

const initialState: ServiceState = {
    error: undefined,
    services: [],
    isUpsertingService: false,
    upsertServiceSuccess: false,
    isUpsertingServiceCategory: false,
    upsertServiceCategorySuccess: false,
}

export default (state: ServiceState = initialState, action: any): ServiceState => {
    switch (action.type) {
        case GET_SERVICES_API: {
            return {
                ...state,
                services: [],
                error: undefined,
            }
        }
        case GET_SERVICES_API_SUCCESS: {
            const successAction = action as getServicesSuccessAction;

            return {
                ...state,
                services: parseDataKey(successAction.services),
                error: undefined,
            }
        }
        case GET_SERVICES_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                services: [],
                error: {
                    type: ServiceErrorOrigin.GET_SERVICES,
                    detail: errorAction.error,
                }
            }
        }
        case UPSERT_SERVICE_API: {
            return {
                ...state,
                upsertServiceSuccess: false,
                error: undefined,
            }
        }
        case UPSERT_SERVICE_API_SUCCESS: {
            return {
                ...state,
                upsertServiceSuccess: true,
                error: undefined,
            }
        }
        case UPSERT_SERVICE_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                services: [],
                error: {
                    type: ServiceErrorOrigin.UPSERT_SERVICE,
                    detail: errorAction.error,
                }
            }
        }
        case GET_SERVICE_CATEGORIES_API: {
            return {
                ...state,
                serviceCategories: undefined,
                error: undefined,
            }
        }
        case GET_SERVICE_CATEGORIES_API_SUCCESS: {
            const successAction = action as getServiceCategoriesSuccessAction;

            return {
                ...state,
                serviceCategories: parseDataKey(successAction.serviceCategories),
            }
        }
        case GET_SERVICE_CATEGORIES_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ServiceErrorOrigin.GET_SERVICE_CATEGORIES,
                    detail: errorAction.error,
                }
            }
        }
        case UPSERT_SERVICE_CATEGORY_API: {
            return {
                ...state,
                upsertServiceCategorySuccess: false,
                error: undefined,
            }
        }
        case UPSERT_SERVICE_CATEGORY_API_SUCCESS: {
            return {
                ...state,
                upsertServiceCategorySuccess: true,
            }
        }
        case UPSERT_SERVICE_CATEGORY_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ServiceErrorOrigin.UPSERT_SERVICE_CATEGORY,
                    detail: errorAction.error,
                }
            }
        }
        case GET_SERVICE_BY_ID_API: {
            return {
                ...state,
                currentService: undefined,
                error: undefined,
            }
        }
        case GET_SERVICE_BY_ID_API_SUCCESS: {
            const successAction = action as GetServiceByIdSuccessAction;

            return {
                ...state,
                currentService: successAction.service,
            }
        }
        case GET_SERVICE_BY_ID_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ServiceErrorOrigin.GET_SERVICE_BY_ID,
                    detail: errorAction.error,
                }
            }
        }
        case GET_SERVICE_BY_ID_API_ERROR: {
            return {
                ...state,
                currentService: undefined,
            }
        }
    }
    return state;
};
